<script>
  import recordSvg from './utils/record.svg';

  export let circleColor
  export let iconPath
  export let record
</script>

<div bind:this={record} class="record relative w-[408px] h-[408px] flex items-center justify-center overflow-visible mid:w-[556px] mid:h-[556px]">
  <img src={recordSvg} alt="record" class="absolute left-1/2 w-full h-full -translate-x-1/2 scale-150" />
  <div class="absolute left-1/2 -translate-x-1/2 scale-150 w-[46%] aspect-square rounded-full">
    <img src="{iconPath}" alt="icon" class="w-full h-full rounded-full object-center object-cover" />
    <img src="{iconPath}" alt="icon" class="absolute top-3.5 left-0 -z-10 w-full h-full rounded-full blur-xl object-center object-cover" />
  </div>
  <div
    class="absolute left-1/2 -translate-x-1/2 scale-150 w-[9%] aspect-square rounded-full"
    style="background-color: {circleColor};"
    >
</div>
</div>

<style>
  .record {
    transition: transform .2s linear;
  }
</style>
